/**
 * Component: Gorgias Scroll script
 * ------------------------------------------------------------------------------
 * Script to stop Gorgias chat widget covering the footer.
 *
 * @namespace gorgias
 */

 import {debounce, on} from '~/helpers/utils';


 /**
  * DOM selectors.
  */
 const selectors = {
   gorgias: '.gorgias-chat-key-sef6vt',
   footer: '#shopify-section-site-footer',
 };

 /**
  * Create a new gorgias chat object.
  */
 export default () => {

   /**
    * DOM node selectors.
    */
   const nodeSelectors = {
     gorgias: document.querySelector(selectors.gorgias),
     footer: document.querySelector(selectors.footer),
   };

   /**
    * Initialise component.
    */
   function init() {
     setEventListeners();
   }

   /**
    * Set event listeners.
    */
   function setEventListeners() {
     on('scroll', debounce(() => checkOffset(), 0, true));
   }

   /**
    * Checks the offset as the user scrolls and adjusts the Gorgias widget style to keep it above the footer.
    */
   function checkOffset() {
     let updatedGorgiasSelector = nodeSelectors.gorgias;

     if (!nodeSelectors.gorgias) {
       updatedGorgiasSelector = document.body.getElementsByClassName('gorgias-chat-key-sef6vt')[0];
     }

     if (updatedGorgiasSelector) {
       const difference = window.innerHeight - getRectTop(nodeSelectors.footer);
       const gorgiasRectTop = getRectTop(updatedGorgiasSelector);
       const scrollTop = document.body.scrollTop;
       const gorgiasOffsetHeight = updatedGorgiasSelector.offsetHeight;
       const footerRectTop = getRectTop(nodeSelectors.footer);
       const innerHeight = window.innerHeight;

       if ((gorgiasRectTop + scrollTop) + gorgiasOffsetHeight >= (footerRectTop + scrollTop) - 10) {
         updatedGorgiasSelector.style.bottom = `${difference}px`;
       } else if (difference > 0) {
         updatedGorgiasSelector.style.bottom = `${difference}px`;
       } else if (scrollTop + innerHeight < (footerRectTop + scrollTop)) {
         updatedGorgiasSelector.style.bottom = '10px';
       }
     }

   }

   function getRectTop(element) {
     try {
       const rect = element.getBoundingClientRect();
       return rect.top;
     } catch {
       return 0;
     }
   }

   /**
    * Expose public interface.
    */
   return Object.freeze({
     init,
   });
 };
